export default {
    methods: {
        openConsentFile (familyId, consent, isFamilyEdition = false) {
            let url;
            const data = {
                familyId,
                consentFileId: consent.id
            };
            if (isFamilyEdition) {
                this.$store.dispatch('family/getFamilyEditionConsentUri', data);
                url = this.$store.getters['family/getConsentLink'];
                window.open(url, '_blank');
                this.$store.commit('family/setConsentLink', null);
            } else {
                this.$store.dispatch('familiesToAccept/getFamilyToAcceptConsentUri', data);
                url = this.$store.getters['familiesToAccept/getConsentLink'];
                window.open(url, '_blank');
                this.$store.commit('familiesToAccept/setConsentLink', null);
            }
        }
    }
};
